import fieldMap from "../../DynamicForm/Fields/FieldMap"
import FieldTypes from "../../Types/FieldTypes"
import legacySchemaBoiler from "../LegacySchemaBoiler"


const buildTemplateWithConfig = {
    /* A function that takes in a config and a schema and returns a template. */
    buildTemplate: (config: Array<Array<any>> | [[]], schema: Array<FieldTypes>) => {
        let template = []
        for (let i = 0; i < config.length; i++) {
            template.push(config[i].slice())
            for (let j = 0; j < template[i].length; j++) {
                const schemaDex = parseInt(config[i][j].Position) + 1
                template[i][j] = { ...schema[schemaDex], ...config[i][j] }
                template[i][j] = { ...template[i][j], ...buildTemplateWithConfig.applyFunctions(template[i][j]) }
            }
        }

        return template
    },
    /* Getting the keys of the object that are not in the legacySchemaBoiler. */
    getForeignKeys: (obj: FieldTypes) => {
        const fieldKeys = Object.keys(obj)
        let foreignKeys = []
        for (let i = 0; i < fieldKeys.length; i++) {
            if (!legacySchemaBoiler.hasOwnProperty(fieldKeys[i])) {
                foreignKeys.push(fieldKeys[i])
            }
        }
        return foreignKeys
    },
    /* Applying functions to the template. */
    applyFunctions: (templateAtPosition: any) => {//!!!!!!!!!!!!! this sucks, make it better
        let template = templateAtPosition
        const foreignKeys = buildTemplateWithConfig.getForeignKeys(template)
        for (let i = 0; i < fieldMap.fields.length; i++) {
            if (template.Type === fieldMap.fields[i].type) {
                const helper = fieldMap.fields[i]
                const triggers = helper.configHelper.triggers
                for (let j = 0; j < foreignKeys.length; j++) {
                    for (let k = 0; k < triggers.length; k++) {
                        if (foreignKeys[j] === triggers[k][0]) {
                            //@ts-ignore
                            const functionList = helper.configHelper[triggers[k][1]]
                            for (let l = 0; l < functionList.length; l++) {
                                if (template[foreignKeys[j]].type === functionList[l].type) {
                                    template[foreignKeys[j]] = functionList[l]
                                }
                            }
                        }
                    }
                }
            }
        }
        return template
    }
}
export default buildTemplateWithConfig